import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";

const api = axios.create({
	baseURL: backendUrl,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: backendUrl,
});

export default api;
